var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.location)?_c('div',{staticClass:"location-marker"},[_c('v-icon',{staticClass:"pr-1",attrs:{"small":""}},[_vm._v("mdi-map-marker")]),_vm._v(" "+_vm._s(_vm.location)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }